module.exports = __webpack_public_path__ + "img/10.89d771e0.jpg";